import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitErrorComponent } from './error/component/init-error/init-error.component';
import { InitErrorGuard } from './error/component/init-error/init-error.guard';
import { PageNotFoundComponent } from './error/component/page-not-found/page-not-found.component';
import { ServiceUnavailableComponent } from './error/component/service-unavailable/service-unavailable.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'vehicles',
    loadChildren: () => import('./vehicles/vehicles.module').then(m => m.VehiclesModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'management',
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule)
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule)
  },
  {
    path: 'ads',
    loadChildren: () => import('./ads/ads.module').then(m => m.AdsModule)
  },
  {
    path: 'ds',
    loadChildren: () => import('./ds/ds.module').then(m => m.DsModule)
  },
  {
    path: 'timetables',
    loadChildren: () => import('./timetables/timetables.module').then(m => m.TimetablesModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./vehicles-menu/vehicles-config.module').then(m => m.VehiclesConfigModule)
  },
  {
    path: 'snvr',
    loadChildren: () => import('./snvr/snvr.module').then(m => m.SnvrModule)
  },
  {
    path: 'files',
    loadChildren: () => import('./files/import-export-files.module').then(m => m.ImportExportFilesModule)
  },
  {
    path: 'software-campaign',
    loadChildren: () => import('./software-campaign/software-campaign.module').then(m => m.SoftwareCampaignModule)
  },
  {
    path: 'translations',
    loadChildren: () => import('./translation/translation.module').then(m => m.TranslationModule)
  },
  {
    path: 'voice-chat',
    loadChildren: () => import('./vehicle-voice-chat/voice-chat.module').then(m => m.VoiceChatModule)
  },
  {
    path: 'sakp-ui',
    loadChildren: () => import('./sakp/sakp.module').then(m => m.SakpModule)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'error-500',
    component: InitErrorComponent,
    canActivate: [InitErrorGuard]
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  {
    path: '503',
    component: ServiceUnavailableComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
